import React from 'react'
import { Typography } from '@material-ui/core'

function Logo() {
    return (
        <Typography variant="h5" color="primary">
            Routing Bot
        </Typography>
    )
}

export default Logo